<div class="user-settings-wrapper">
  <!-- Enhanced Header Section -->
  <div class="template-header">
    <div class="header-content">
      <h1 class="template-title">User Settings</h1>
      <p class="template-description">
        Configure your personal preferences for event notifications and messages.
      </p>
    </div>
  </div>

  <!-- Settings Section -->
  <ng-container *ngIf="guild && userInfo$ | async as userInfo">
    <div class="settings-section">
      <div class="section-header">
        <h2 class="section-title">Notification Settings</h2>
        <mat-icon class="section-icon">notifications</mat-icon>
      </div>
      <div class="toggleSubscribeConfirmMessage">
        <mat-slide-toggle
          [checked]="userInfo.get_confirmed_message"
          (change)="toggleSubscribeConfirmMessage()">
          Get a DM when you are confirmed for an event
          <!-- TODO: Doc and cooldown -->
          <small class="form-text text-muted">/toggle_subscribe_confirm_message</small>
        </mat-slide-toggle>
      </div>
    </div>
<!--
    <div class="settings-section">
      <div class="section-header">
        <h2 class="section-title">Google Calendar</h2>
        <mat-icon class="section-icon">event</mat-icon>
      </div>
      <div class="google-calendar-info">
        <p class="google-calendar-description">
          Connect Google Calendar to automatically highlight conflicts with your Raid Organizer events.
        </p>
        <span class="premium-tag">
          <mat-icon class="premium-tag-icon">workspace_premium</mat-icon>
          Calendar conflict detection is a premium feature
        </span>
        <div class="privacy-note">
          <mat-icon class="privacy-note-icon">verified_user</mat-icon>
          <span>Your privacy matters: We fetch events on the fly and never store your calendar data in our database.</span>
        </div>
      </div>
      <div *ngIf="googleCalendarConfigured" class="google-calendar-actions">
        <button *ngIf="!googleCalendarConnected" mat-raised-button color="primary" (click)="connectGoogleCalendar()">
          <mat-icon>link</mat-icon>
          Connect Google Calendar
        </button>
        <div *ngIf="googleCalendarConnected" class="google-calendar-connected">
          <mat-icon class="connected-icon">check_circle</mat-icon>
          <span>Google Calendar connected</span>
          <button mat-button color="warn" (click)="disconnectGoogleCalendar()">Disconnect</button>
        </div>
      </div>
      <p *ngIf="!googleCalendarConfigured" class="text-muted small">Google Calendar sync is not configured for this instance.</p>
    </div> -->
  </ng-container>
</div>
